import { environment } from '../../../environments/environment';
export class SETTINGS {
  public static ACCESS_TOKEN = '%&^%^*@&*#';
  public static REFRESH_TOKEN = '&@&#&$(@&##';
  public static LOGGED_IN_USER = '#$%@^^%';

  public static BASE_API = environment.baseURL; // do not change this

  public static KEYS = {
    SECRET: 'iIUsWtNZcf',
  };

  public static STRIPE = {
    // Testing purpose publish key
    PUBLISHABLE_KEY: 'pk_test_qblFNYngBkEdjEZ16jxxoWSM',
  };


  public static REGEX = {
    PASSWORD: {
      EXP: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$',
    },
    PHONE: {
      EXP: '^[0-9]{1,10}$',
    },
    ID: {
      EXP: '^[0-9]{9}v$',
    },
    LETTERS: {
      EXP: '[a-zA-Z\\s]*$',
    },
  };
  public static ANNOUNCEMENT_RECIPIENT = [
    { label: "Users", value: "USER" },
    { label: "Members", value: "MEMBER" }
  ];
  public static USERS = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADMIN: "ADMIN",
    SUPPORT: "SUPPORT",
    STAFF: "STAFF",
    MEMBER: "MEMBER",
  };
}
